const microHaematuria = [

    { 
    label:"Seen on::",
    controlType:"checkbox group",
    options:["Dipstick", "Lab Test"]
    }, 

    { 
    label:"Amount:",
    controlType:"radio button",
    options:["+", "++", "+++", "++++"]
    }, 

    { 
    label:"Haemolysis:",
    controlType:"radio button",
    options:["Haemolysed", "Non-haemolysed"]
    },

]

export default microHaematuria